import { ClinicCompatibleAuthProvider } from "@repo/core/contexts/ClinicCompatibleAuthContext";

import type { ComponentProps } from "react";

type AppProvidersProps = ComponentProps<typeof ClinicCompatibleAuthProvider>;

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ClinicCompatibleAuthProvider>{children}</ClinicCompatibleAuthProvider>
  );
}
